import { Alert, AlertDescription } from "@/components/ui/alert";
import { Progress } from "@/components/ui/progress";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import { ChunkProgress } from "@/lib/batchUploadChunker";

interface BatchUploadProgressAlertProps {
  progress: ChunkProgress | null;
  uploading: boolean;
}

export function BatchUploadProgressAlert({ progress, uploading }: BatchUploadProgressAlertProps) {
  if (!uploading || !progress) return null;

  const percent = Math.round((progress.processed / progress.total) * 100);

  return (
    <Alert className="border-primary/30 bg-primary/5">
      <Loader2 className="h-4 w-4 animate-spin text-primary" />
      <AlertDescription className="space-y-3">
        <div className="flex items-center justify-between text-sm font-medium">
          <span>Uploading receipts in chunks...</span>
          <span>{progress.processed}/{progress.total}</span>
        </div>
        <Progress value={percent} className="h-2" />
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Chunk {progress.currentChunk} of {progress.totalChunks}</span>
          {progress.failed > 0 && (
            <span className="flex items-center gap-1 text-orange-600">
              <AlertCircle className="w-3 h-3" />
              {progress.failed} failed
            </span>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
}
